var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.95431 31.0457 0 20 0C8.95429 0 0 8.95431 0 20C0 31.0457 8.95429 40 20 40Z",
    fill: "#FF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7077 17.0917C30.7077 14.4394 28.5574 12.2891 25.9051 12.2891H13.6241C10.9717 12.2891 8.82138 14.4394 8.82138 17.0917V22.8068C8.82138 25.4592 10.9717 27.6095 13.6241 27.6095H25.9051C28.5574 27.6095 30.7077 25.4592 30.7077 22.8068V17.0917ZM23.4852 20.3774L17.9781 23.1023C17.7619 23.2186 17.0288 23.0626 17.0288 22.8178V17.2244C17.0288 16.9755 17.7688 16.8195 17.9849 16.9426L23.2568 19.8111C23.477 19.937 23.7096 20.2571 23.4852 20.3774Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/Youtube_Icon.fed88c89c94d021e446411412404c6c8.svg";
export { ForwardRef as ReactComponent };